import React, { useEffect, useState } from 'react';

import LinkComponent from '../../../components/common/Link';
import PillarAPI from '../../PillarContainer/pillar-api';
import WorkshopInfoForm from './WorkshopInfoForm';
import WorkshopSummary from './WorkshopSummary';
import WorkshopWizard from './WorkshopWizard';
import { createDefaultWorkshopData } from '../utils/workshopForm';

const WorkShopCreation = () => {
  const [activeStep, setActiveStep] = useState(0);
  const [workShopData, setWorkShopData] = useState(createDefaultWorkshopData);
  const [pillarList, setPillarList] = useState([]);
  const [isLoadingPillars, setIsLoadingPillars] = useState(true);

  useEffect(() => {
    PillarAPI.fetchActivePillars()
      .then((response) => {
        setPillarList(response.data || []);
      })
      .catch((error) => {
        console.error('Error al obtener los pilares:', error);
      })
      .finally(() => {
        setIsLoadingPillars(false);
      });
  }, []);

  const onNext = () => {
    setActiveStep((prevStep) => prevStep + 1);
  };
  const onPrev = () => {
    setActiveStep((prevStep) => prevStep - 1);
  };

  const workShopSteps = [
    {
      title: 'Información del taller',
      render: () => (
        <WorkshopInfoForm
          mode="create"
          onNext={onNext}
          workShopData={workShopData}
          setWorkShopData={setWorkShopData}
          pillars={pillarList}
          isLoadingPillars={isLoadingPillars}
        />
      ),
    },
    {
      title: 'Resumen',
      render: () => (
        <WorkshopSummary
          mode="create"
          workshopData={workShopData}
          onPrev={onPrev}
        />
      ),
    },
  ];

  return (
    <div className="client-container">
      <div className="client__back-container">
        <LinkComponent title="Volver" url="/talleres" icon="arrow_back" />
      </div>

      <WorkshopWizard
        title="Crear nuevo taller"
        steps={workShopSteps}
        activeStep={activeStep}
      />
    </div>
  );
};

export default WorkShopCreation;
